import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import 'tachyons';
import "./assets/css/style.css";
import "./assets/css/oldie.css";
import "./assets/css/custom.css";
import "./assets/css/skin/green.css";

import App from "./App";

ReactDOM.render(<App/>, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js